import {
  SearchAlienationFourriereFluxDto,
  SearchFluxFourriereUsingGETQueryParamsSortDto,
} from 'lib_api/lib/api/gen';

import {
  TablePagination,
  TableSort,
} from 'components/WrappedComponents/Table/types';

import { FilterDashboardFlux } from '../../types';
import { SearchAlienationResponse } from '../shared/types';
import { useSearchFluxsAlienation } from '../shared/utils';

import { FluxFourriereSortType } from './types';

export function useSearchFluxLieuxDepot(
  _: FilterDashboardFlux,
  sorts: TableSort<FluxFourriereSortType>,
  pagination: TablePagination,
): SearchAlienationResponse<SearchAlienationFourriereFluxDto> {
  return useSearchFluxsAlienation<
    SearchAlienationFourriereFluxDto,
    SearchFluxFourriereUsingGETQueryParamsSortDto,
    FluxFourriereSortType
  >(
    sorts,
    pagination,
    controller => controller.searchFluxFourriereUsingGET.bind(controller),
    sorts => {
      return {
        dateAppel: sorts?.DATE_APPEL,
      };
    },
  );
}
